import { LicenseListItem } from 'pages/UserInfo/components/License/types';

export const Endpoint = () => `/api/v3/admin/userinfo/`;
export const Csrf = () => `/api/v3/admin/token/`;
export const QueryKey = (userId: string) => ['v3', 'admin', 'reports', 'user-info', userId] as const;

export interface User {
    firstName: string;
    lastName: string;
    email: string;
    telegram: string;
    published: string;
    lastlogin: { date: string }[];
    amount: number;
    amount_unlimited_until: string;
}

export interface ApiKey {
    id: string;
    licenseId: string;
}

export interface CreditHistoryItem {
    published: string;
    requests: {
        [type: string]: {
            [path: string]: number;
        };
    };
    cost: {
        [type: string]: {
            [path: string]: number;
        };
    };
}

export interface ApiStatItem {
    amount: number;
    credit_history: CreditHistoryItem[];
    licenseType: string;
}

export interface Response {
    user: User;
    license_list: LicenseListItem[];
    api_keys: ApiKey[];
    api_stats: ApiStatItem[];
    subscription_count: number;
    scan_count: number;
    agent_count: number;
}
